import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EPackageListSortField,
  IPackageList,
  PPackageListFilter,
} from "src/core/packageList/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IPackageListState {
  packageLists: IPackageList[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IPackageListState = {
  packageLists: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "package-list/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "package-list/FETCH_SUCCEEDED";
const FETCH_FAILED = "package-list/FETCH_FAILED";
const POLLING_START_REQUESTED = "package-list/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "package-list/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IPackageList[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PPackageListFilter;
    pagination: IPagination;
    sorts: ISort<EPackageListSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IPackageListState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IPackageListState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.packageLists = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
